import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CustomTable from "../components/CustomTable";
import DataSelect from "../components/DataInputs/DataSelect";
import DataTextField from "../components/DataInputs/DataTextField";
import FilterBase from "../components/Filter";
import usePagination from "../hooks/Pagination";
import {
	ManagerFilter,
	ManagerSearch,
	ManagerTable,
} from "../interfaces/Manager";
import {
	ArrayContainer,
	Filter,
	Pagination,
	ResponseContainer,
	Sort,
} from "../interfaces/RequestBase";
import { TableTemplate } from "../interfaces/Table";
import { GetManagers, GetRoles } from "../requester/functions";
import getFilter from "../utilities/filter";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { useNavigate } from "react-router-dom";
import { RoleList } from "../interfaces/Role";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { getFullName } from "../utilities/string";

interface IProps {}

const ManagesPage = (props: IProps) => {
	const navigate = useNavigate();

	const [managers, setManagers] = useState<ManagerTable[]>([]);
	const [pagination, setPage, setPageSize] = usePagination();
	const [filter, setFilter] = useState<ManagerFilter>({});
	const [search, setSearch] = useState<ManagerSearch>({});
	const [sort, setSort] = useState<Sort>({});
	const [totalCount, setTotalCount] = useState<number>(0);

	const [role, setRole] = useState<RoleList[]>([]);

	const rows: TableTemplate = {
		data: [
			{
				title: "ФИО",
				sortKey: "last_name",
				render: (item: ManagerTable) =>
					getFullName(item.first_name, item.last_name, item.patronymic),
			},
			{
				title: "Телефон",
				key: "phone",
				sortKey: "phone",
			},
			{
				title: "Почта",
				key: "email",
				sortKey: "email",
			},
			{
				title: "Должность",
				key: "position",
				sortKey: "position",
			},
			{
				title: "Роль",
				sortKey: "role.name",
				render: (item: ManagerTable) => item.role.name,
			},
			{
				title: "",
				render: (item: ManagerTable) => (
					<IconButton
						onClick={() => {
							navigate(`/manager/${item.id}`);
						}}
					>
						<AccountBoxIcon />
					</IconButton>
				),
			},
		],
	};
	useEffect(() => {
		GetRoles({}, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setRole(resp.data);
			}
		});
	}, []);

	const getManagersExport = (callback: any) => {
		var req: Filter<ManagerFilter, ManagerSearch> = getFilter(
			{ page: 0, size: totalCount } as Pagination,
			filter,
			search,
			sort
		);
		GetManagers(
			req,
			(resp: ResponseContainer<ArrayContainer<ManagerTable>>) => {
				if (resp.status === "ok" && resp.data) {
					callback(resp.data.data);
				}
			}
		);
	};

	useEffect(() => {
		var req: Filter<ManagerFilter, ManagerSearch> = getFilter(
			pagination as Pagination,
			filter,
			search,
			sort
		);
		GetManagers(
			req,
			(resp: ResponseContainer<ArrayContainer<ManagerTable>>) => {
				if (resp.status === "ok" && resp.data) setManagers(resp.data.data);
				setTotalCount(resp.data?.total_count || 0);
			}
		);
	}, [filter, pagination, search, sort]);

	return (
		<div className="flex flex-col items-end gap-5">
			<div className="flex justify-between w-full">
				<IconButton
					onClick={() => {
						navigate("/manager/create");
					}}
				>
					<PersonAddAlt1Icon />
				</IconButton>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						keyValue={"full_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Имя" }}
					/>
					<DataTextField
						keyValue={"phone"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Телефон" }}
					/>
					<DataTextField
						keyValue={"email"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Почта" }}
					/>
					<DataTextField
						keyValue={"position"}
						value={filter}
						setValue={setFilter}
						inputProps={{ label: "Должность" }}
					/>
					<DataSelect
						keyValue={"role"}
						list={role}
						value={filter}
						setValue={setFilter}
						label="Роль"
					/>
				</FilterBase>
			</div>
			<CustomTable
				rows={rows}
				data={managers}
				allCount={totalCount}
				pagination={pagination as Pagination}
				setPage={setPage as (p: number) => void}
				setPageSize={setPageSize as (p: number) => void}
				sort={sort}
				setSort={setSort}
				onExport={getManagersExport}
			/>
		</div>
	);
};

export default ManagesPage;
